import {combineReducers} from "redux"

import {intakeFailuresById} from "./reducers/intakeFailuresById"
import {ui} from "./reducers/ui"
import {ticketsById} from "./reducers/ticketsById"

export const rootReducer = combineReducers({intakeFailuresById, ui, ticketsById})
